import React, { useContext } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { EPaths } from '../types/enums/EPaths';
import {
  Dashboard,
  Packages,
  Customers,
  SystemUsers,
  Notifications,
  CarrierStatus,
  PartnerCodes,
  InAppNotification,
} from '../containers';
import MyProfile from '../containers/MyProfile/MyProfile';
import EditPackage from '../containers/Packages/EditPackage/EditPackage';
import EditSystemUser from '../containers/SystemUsers/EditSystemUser/EditSystemUser';
import ViewCustomer from '../containers/Customers/ViewCustomer/ViewCustomer';
import AddCustomer from '../containers/Customers/AddCustomer/AddCustomer';

import NotFound from '../containers/NotFound/NotFound';
import PromoCodes from '../containers/PromoCodes/PromoCodes';
import Receipt from '../containers/Receipt/Receipt';
import { SessionContext } from '../contexts/session/SessionContext';
import NoPermission from '../containers/NoPermission/NoPermission';
import AddSystemUser from '../containers/SystemUsers/AddSystemUser/AddSystemUser';
import VerifyEmail from '../containers/VerifyEmail/VerifyEmail';
import ResetPassword from '../containers/ResetPassword/ResetPassword';
import ConfirmationSupport from '../containers/ConfirmationSupport/ConfirmationSupport';
import Settings from '../containers/AppSettings/Settings';
import AddPartnerCode from '../containers/PartnerCodes/AddPartnerCode/AddPartnerCode';
import EditPartnerCode from '../containers/PartnerCodes/EditPartnerCode/EditPartnerCode';
import AddNotification from '../containers/InAppNotifications/AddNotification/AddNotification';
import EditNotification from '../containers/InAppNotifications/EditNotification/EditNotification';
import AddPromoCampaign from '../containers/PromoCampaigns/AddPromoCampaign/AddPromoCampaign';
import EditPromoCampaign from '../containers/PromoCampaigns/EditPromoCampaign/EditPromoCampaign';
import PromoCampaigns from '../containers/PromoCampaigns/PromoCampaigns';

const PrivateRoutes = () => {
  const { permissions } = useContext(SessionContext);
  return (
    <Switch>
      <Route path={EPaths.Dashboard} component={Dashboard} />
      {/* <Route path={`${../containers/AppSettings/Settingst={permissions.packages.edit ? EditPackage : NoPermission} /> */}
      <Route path={`${EPaths.Packages}/:id`} component={permissions.packages.view ? EditPackage : NoPermission} />
      <Route path={EPaths.Packages} component={permissions.packages.view ? Packages : NoPermission} />
      <Route path={`${EPaths.Customers}/add`} component={permissions.customers.edit ? AddCustomer : NoPermission} />
      <Route path={`${EPaths.Customers}/:id`} component={permissions.customers.view ? ViewCustomer : NoPermission} />
      <Route path={EPaths.Customers} component={permissions.customers.view ? Customers : NoPermission} />
      <Route
        path={`${EPaths.SystemUsers}/add`}
        component={permissions.systemUsers.edit ? AddSystemUser : NoPermission}
      />
      <Route
        path={`${EPaths.SystemUsers}/:id`}
        component={permissions.systemUsers.edit ? EditSystemUser : EditSystemUser}
      />
      <Route path={EPaths.SystemUsers} component={permissions.systemUsers.view ? SystemUsers : SystemUsers} />

      <Route
        path={`${EPaths.PromoCampaigns}/add`}
        component={permissions.promoCampaigns.edit ? AddPromoCampaign : NoPermission}
      />
      <Route
        path={`${EPaths.PromoCampaigns}/:id`}
        component={permissions.promoCampaigns.edit ? EditPromoCampaign : EditPromoCampaign}
      />
      <Route
        path={EPaths.PromoCampaigns}
        component={permissions.promoCampaigns.view ? PromoCampaigns : PromoCampaigns}
      />

      {/*
       // TODO: uncomment in MVP 2
      <Route
        path={`${EPaths.Calculator}/add`}
        component={permissions.calculator.edit ? AddCalculator : NoPermission}
      />
      <Route
        path={`${EPaths.Calculator}/:id`}
        component={permissions.calculator.edit ? EditCalculator : NoPermission}
      />
      <Route
        path={EPaths.Calculator}
        component={permissions.calculator.view ? Calculator : NoPermission}
      /> */}
      {/* <Route
        path={EPaths.Notifications}
        component={permissions.notifications.view ? Notifications : NoPermission}
      /> */}
      <Route path={EPaths.VerifyEmail} component={permissions.notifications.view ? VerifyEmail : NoPermission} />
      <Route path={EPaths.ResetPassword} component={permissions.notifications.view ? ResetPassword : NoPermission} />
      <Route
        path={EPaths.ConfirmationSupport}
        component={permissions.notifications.view ? ConfirmationSupport : NoPermission}
      />
      <Route
        path={`${EPaths.InAppNotifications}/add`}
        component={permissions.notifications.view ? AddNotification : AddNotification}
      />
      <Route
        path={`${EPaths.InAppNotifications}/:id`}
        component={permissions.notifications.view ? EditNotification : EditNotification}
      />
      <Route
        path={EPaths.InAppNotifications}
        component={permissions.notifications.view ? InAppNotification : InAppNotification}
      />

      <Route path={EPaths.CarrierStatus} component={permissions.carrierStatus.view ? CarrierStatus : NoPermission} />
      <Route path={EPaths.MyProfile} component={MyProfile} />
      <Route path={EPaths.PromoCodes} component={permissions.promocodes.view ? PromoCodes : NoPermission} />
      <Route path={EPaths.Receipt} component={Receipt} />
      <Route path={EPaths.NoPermissions} component={NoPermission} />
      <Route path={EPaths.Settings} component={permissions.appSettings.view ? Settings : NoPermission} />
      {/* <Route
        path={`${EPaths.PartnerCodes}/add`}
        component={permissions.partnercodes.edit ? AddPartnerCode : NoPermission}
      />
      <Route
        path={`${EPaths.PartnerCodes}/:id`}
        component={permissions.partnercodes.view ? EditPartnerCode : NoPermission}
      />
      <Route path={EPaths.PartnerCodes} component={permissions.partnercodes.view ? PartnerCodes : NoPermission} /> */}
      <Route exact path="/">
        <Redirect to={EPaths.Dashboard} />
      </Route>
      <Route path="*" component={NotFound} />
    </Switch>
  );
};

export default PrivateRoutes;
